import { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.recamix.com';

export const useEmailApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const generateEmail = async (emailData) => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(`${API_URL}/email-writer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: emailData.type,
          purpose: emailData.purpose,
          tone: emailData.tone,
          recipient: emailData.recipient,
          subject: emailData.subject,
          content: emailData.content,
          additionalInfo: emailData.additionalInfo
        })
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || '이메일 생성에 실패했습니다.');
      }

      setResult(data.data);
      return data.data;

    } catch (error) {
      setError(error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const clearResult = () => setResult(null);
  const clearError = () => setError(null);

  return {
    loading,
    error,
    result,
    generateEmail,
    clearResult,
    clearError
  };
}; 